<template>
    <fieldset class="flex flex-col gap-1" :class="{ 'md:flex-row md:items-center w-full': isHorizontal }">
        <label v-if="showLabel" :for="inputId" class="font-bold" :class="{ 'md:w-1/4': isHorizontal }">
            {{ label }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <div class="flex flex-col gap-1" :class="{ 'md:w-1/4': isHorizontal }">
            <slot :input-id :touch :is-horizontal="isHorizontal" />
            <div v-if="description" class="text-sm text-muted" v-html="description"></div>
            <slot name="warning" />
            <div v-if="issues[key]" class="text-sm text-danger">{{ issues[key] }}</div>
        </div>
    </fieldset>
</template>
<script setup lang="ts">
import type { FormFieldProps, LayoutType } from "~/utils/types/FormFieldProps";
import { FormInjectKey } from "../form/Form.vue";
const {
    label,
    field: key,
    required = false,
    description = "",
    hideLabel = false,
} = defineProps<FormFieldProps & { hideLabel?: boolean }>();

const { issues, touched, formLayout } = inject(FormInjectKey, {
    issues: computed<Record<string, string>>(() => ({})),
    touched: ref<Record<string, boolean>>({}),
    formLayout: ref<LayoutType>("vertical"),
});

const isHorizontal = formLayout.value === "horizontal";
const showLabel = !hideLabel || isHorizontal;
const inputId = "form-field-" + key.toLowerCase();

function touch() {
    touched.value[key] = true;
}
</script>
